/**
 * <Comente>
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Switch = (function () {

    function Switch () {

        Monet.UI.Fields.Checkbox.apply(this, arguments);

        this.switchDiv = null;

        const checkedClass = 'MonetUIFieldSwitchChecked';
        const uncheckedClass = 'MonetUIFieldSwitchUnChecked';

        this.setValue = function (value) {

            this.value = value;
            if (this.value) {
              this.setCheckedStatus();
            }
            else {
              this.setUncheckedStatus();
            }
        };

        this.getValue = function () {

            return this.value;
        };

        const switchCheckboxStatus = function (field) {
            return () => { field.setValue(!field.getValue()); };
        }(this);

        this.setCheckedStatus = function () {
          this.label.innerHTML = this.checkedLabel || '';
          this.switchDiv.className = checkedClass;
          this.input.checked = true;
        }

        this.setUncheckedStatus = function () {
          this.label.innerHTML = this.uncheckedLabel || '';
          this.switchDiv.className = uncheckedClass;
          this.input.checked = false;
        }

        this.setCheckedLabel = function (checkedLabel) {
            this.checkedLabel = Monet.I18n.getResourcesByKey(checkedLabel);
        };

        this.setUncheckedLabel = function (uncheckedLabel) {
            this.uncheckedLabel = Monet.I18n.getResourcesByKey(uncheckedLabel);
        };

        this.customCreateElement = function () {
            const switchContainer = document.createElement("label");
            switchContainer.setAttribute("for", this.name);
            this.switchDiv = document.createElement('div');
            this.rootEl.appendChild(switchContainer);
            switchContainer.appendChild(this.switchDiv);
        };

        this.addListeners = function () {

            if (this.input) {

                this.input.removeEventListener('change', switchCheckboxStatus);
                this.input.addEventListener('change', switchCheckboxStatus);

            }

        };

        this.setDefaultValue = function (defaultValue) {
          this.setValue(defaultValue);
        };

        this.render = function () {
            this.createElement();
            this.customCreateElement();
            this.addListeners();
            this.setUncheckedStatus();
            this.rootEl.className = 'MonetUIFieldSwitch';

            return this.rootEl;
        };

    }

    return Switch;

}());